export default __webpack_public_path__ + "static/media/powered.9d5d8b6b.png";